Backbone = require 'backbone'
SpinnerTemplate = require '../../spinner.html.mustache'

module.exports = SpinnerView = Backbone.View.extend
  template: SpinnerTemplate

  initialize: ({@parentElem, @css, @useV2}) ->
    @parentElem?.append? @$el

  render: ->
    @stop()
    @$el.html(@template.render({@useV2}))
    if @useV2
      @$el.find('.g-spinner').css(@css) if @css?
    else
      @$el.find('.t-spinner-small').css(@css) if @css?
    this

  isRunning: ->
    @$el.is(':visible')

  isInDom: ->
    $.contains(document.documentElement, @$el[0])

  start: ->
    @parentElem?.append? @$el if not @isInDom()
    @$el.show()

  stop: ->
    @$el.hide()
